import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import { handleLogin } from '../../utils/authentication';

import User from '../../models/User';

import roleConfig from '../../configs/roles'; 

interface GhaRouteProps {
  component: any;
  user: User;
  isAuthenticated: boolean;
  location: any;
  componentProps: any;
};

class GhaRoute extends Component<GhaRouteProps> {

  componentDidMount() {
    handleLogin();
  };

  loadPermission = (): boolean => {

    const userRole: number = this.props.user.roleId;
    const configRole: {[key: string]: number } = roleConfig.roleId;

    switch (this.props.location) {
      case '/manage-imports' : 
      case '/manage-exports' :
      case '/my-go-orders':
      case '/create-go-order':
      case '/cart-go':
      case '/pay-go':
      case '/go/:orderNumber':
      case '/manual-entry-import':
      case '/manual-entry-export':
      case '/manual-entry-cart':
      case '/manual-entry-pay':
      case '/manual-entry-issue-po':
      case '/manual-entry-truck':
      case '/manual-entry-drop-off-order':
      case '/tapa':
      case '/dashboard':
        return !!(userRole === configRole.ghaOffice || userRole === configRole.laxOfficeAgent || userRole === configRole.ghaSupervisor || userRole === configRole.ghaManager || userRole === configRole.ghaDashboard || userRole === configRole.ghaManagerWh || userRole === configRole.superUser || userRole === configRole.ghaWarehouseScreener || userRole === configRole.ghaWarehouse);
      case '/driver-queue-list':
        return !!(userRole === configRole.ghaManager || userRole === configRole.ghaDashboard || userRole === configRole.superUser);
      case '/payment-report' : 
        return !!(userRole === configRole.ghaManager || userRole === configRole.superUser || userRole === configRole.ghaAccounting || userRole === configRole.ghaAdmin || userRole === configRole.ghaAccReco);
      case '/awb-info' : 
        return !!(userRole === configRole.ghaOffice || userRole === configRole.laxOfficeAgent || userRole === configRole.ghaSupervisor || userRole === configRole.ghaManager || userRole === configRole.ghaAccounting || userRole === configRole.ghaAirlineRepresentative || userRole === configRole.ghaManagerWh || userRole === configRole.ghaSupervisorWh || userRole === configRole.superUser);
      case '/whs/po/note/:number':
      case '/whs/go/note/:number':
      case '/whs/do/note/:number':
      case '/whs/rfs/note/:number':
      case '/whs/po/awb/report/:orderNumber/:awbCode/:awbNumber/:awbVersion':
      case '/whs/go/awb/report/:orderNumber/:awbCode/:awbNumber/:awbVersion':
      case '/whs/do/awb/report/:orderNumber/:awbCode/:awbNumber/:awbVersion':
      case '/whs/do/awb/weight/:orderNumber/:awbCode/:awbNumber/:awbVersion':
      case '/whs/rfs/awb/report/:orderNumber/:awbCode/:awbNumber/:awbVersion':
      case '/whs/rfs/awb/weight/:orderNumber/:awbCode/:awbNumber/:awbVersion':
      case '/whs/po/:number':
      case '/whs/go/:number':
      case '/whs/do/:number':
      case '/whs/rfs/:number':
      case '/whs/po/drv-signature/:number':
      case '/whs/go/drv-signature/:number':
      case '/whs/do/drv-signature/:number':
      case '/whs/rfs/drv-signature/:number':
      case '/whs/do/return-drv-signature/:number':
      case '/whs/do/return-drv-signature/:number/:awbCode/:awbNumber/:awbVersion':
      case '/whs/order-awb-search':
      case '/whs/pod/:awbCode/:awbNumber/:awbVersion':
        return !!(userRole === configRole.ghaSupervisor || userRole === configRole.laxOfficeAgent || userRole === configRole.ghaManager || userRole === configRole.ghaWarehouse || userRole === configRole.ghaWarehouseScreener || userRole === configRole.ghaManagerWh || userRole === configRole.ghaSupervisorWh || userRole === configRole.superUser);
      case '/user-management':
      case '/print-user-details':
        return !!(userRole === configRole.ghaManager || userRole === configRole.ghaAdmin || userRole === configRole.forwarderAdmin || userRole === configRole.superUser || userRole === configRole.ghaManagerWh);
      case '/dock-activity':
        return !!(userRole === configRole.ghaWarehouse || userRole === configRole.ghaSupervisor || userRole === configRole.ghaManager || userRole === configRole.ghaWarehouseScreener || userRole === configRole.superUser || userRole === configRole.ghaSupervisorWh || userRole === configRole.ghaManagerWh);
      case '/dashboard-waiting-list':
      case '/whs-dashboard':
        return !!(userRole === configRole.ghaOffice || userRole === configRole.ghaSupervisor || userRole === configRole.ghaManager || userRole === configRole.ghaDashboard || userRole === configRole.ghaManagerWh || userRole === configRole.ghaSupervisorWh || userRole === configRole.superUser || userRole === configRole.ghaWarehouse || userRole === configRole.ghaWarehouseScreener);
      case '/fwd-accounts':
        return !!(userRole === configRole.superUser || userRole === configRole.ghaAdmin || userRole === configRole.ghaAccounting);
      case '/screening/:code?/:number?/:version?/:orderNumber?':
        return !!(userRole === configRole.ghaSupervisor || userRole === configRole.laxOfficeAgent || userRole === configRole.ghaManager || userRole === configRole.ghaScreener || userRole === configRole.ghaWarehouseScreener || userRole === configRole.ghaAccounting || userRole === configRole.ghaManagerWh || userRole === configRole.ghaSupervisorWh || userRole === configRole.superUser || userRole === configRole.ghaWarehouse);
      case '/screening-report':
        return !!(userRole === configRole.ghaSupervisor || userRole === configRole.laxOfficeAgent || userRole === configRole.ghaManager || userRole === configRole.ghaOffice || userRole === configRole.ghaScreener || userRole === configRole.ghaWarehouseScreener || userRole === configRole.ghaAccounting || userRole === configRole.ghaManagerWh || userRole === configRole.ghaSupervisorWh || userRole === configRole.superUser || userRole === configRole.ghaAirlineRepresentative);
      case '/shipment-inventory':
        return !!(userRole === configRole.ghaOffice || userRole === configRole.laxOfficeAgent || userRole === configRole.ghaAirlineRepresentative || userRole === configRole.ghaSupervisor || userRole === configRole.ghaManager || userRole === configRole.ghaAccounting || userRole === configRole.ghaManagerWh || userRole === configRole.ghaSupervisorWh || userRole === configRole.superUser);
      case '/create-rfs/:id?':
        return !!(userRole === configRole.ghaSupervisor || userRole === configRole.laxOfficeAgent || userRole === configRole.ghaOffice || userRole === configRole.ghaOfflineRFSRep || userRole === configRole.ghaOffice || userRole === configRole.ghaManager || userRole === configRole.ghaSupervisor || userRole === configRole.superUser);
      case '/create-manifest/:id?':
        return !!(userRole === configRole.ghaSupervisor || userRole === configRole.laxOfficeAgent || userRole === configRole.ghaOffice || userRole === configRole.ghaOfflineRFSRep || userRole === configRole.ghaOffice || userRole === configRole.ghaManager || userRole === configRole.ghaSupervisor || userRole === configRole.superUser);
      case '/manage-rfs':
        return !!(userRole === configRole.ghaSupervisor || userRole === configRole.laxOfficeAgent || userRole === configRole.ghaOffice || userRole === configRole.ghaOfflineRFSRep || userRole === configRole.ghaOffice || userRole === configRole.ghaManager || userRole === configRole.ghaSupervisor || userRole === configRole.superUser);
      case '/dashboard':
        return !!(userRole === configRole.ghaDashboard);
      case '/analytics/:tab?':
        return !!(userRole === configRole.ghaSupervisor || userRole === configRole.ghaManager || userRole === configRole.ghaAdmin || userRole === configRole.ghaAirlineRepresentative);

      default : return false;
    }
  }
  

  render() {
    const { component: Component, user, isAuthenticated, location, componentProps, ...rest } = this.props;
    if (this.props.isAuthenticated !== null) {
      return (
        <Route
          { ...rest }
          render={ props =>
            this.props.isAuthenticated && this.loadPermission()
            ? <Component { ...props } { ...componentProps } />
            : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
          }
        />
      ); 
    }
    return null;
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    isAuthenticated: state.auth.success,
    user: state.user,
    location: ownProps.path
  };
};

export default connect(mapStateToProps, null)(GhaRoute);